import { createContext, useContext } from 'react';

export interface AdminInviteUsersContextType {
  // Data
  rows: string[];
}

export const AdminInviteUsersContext =
  createContext<AdminInviteUsersContextType | null>(null);
AdminInviteUsersContext.displayName = 'AdminInviteUsersContext';

export const useAdminInviteUsersContext = () => {
  const context = useContext(AdminInviteUsersContext);
  if (!context) {
    throw new Error(
      'useAdminInviteUsersContext must be used within a AdminInviteUsersContextProvider',
    );
  }
  return context;
};
